import React, { useState } from 'react';
import CisList from './CisList';
import LoadSimple from '../LoadSimple';
import Modal from 'react-modal';
import ModalDeleteCis from "./ModalDeleteCis";
import ModalReqAuth from './ModalReqAuth';
import { lang } from '../generales/traduction';
import { capitalizeFirstLetter } from '../../utils/utils';
const deleteCisModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'30%',
    height:'20%',
    padding:'20px'
  },
};
const deleteBuzonModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'40%',
    height:'30%',
    padding:'20px'
  },
};
const TableCisConfig = ({ buscar_cis_history,handleChangEdit,
  cisSelected,setCisSelected,searchResults, setSearchResults,onSearch,
  dataUsers,setDataUsers,searchTerm, setSearchTerm,server,dataCisConf,
languaje,mode
}) => {
  const [deleteCisModalOpen, setdeleteCisModalOpen] =useState(false);
  const [data,setData]=useState([]);
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState(null);
  const [registerIsValid, setRegisterIsValid] = useState(false);
  const [cisConfSelected,setCisConfSelected]=useState({})
  const [deleteBuzonModalOpen, setdeleteBuzonModalOpen] =useState(false);
  const [userSelected,setUserSelected]=useState({})
  function openDeleteUserModalauth() {
    setdeleteBuzonModalOpen(true);
  }

  function closDeleteBuzonModal() {
    setdeleteBuzonModalOpen(false);
  }
  const handleActionResponse = (data) => {
    
    setUserSelected(data)
    openDeleteUserModalauth()
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  var dataList=(searchTerm==='')?((dataCisConf.data.length==0)?[]:dataCisConf.data.data.history):searchResults;
  const handledeleteUserClick = (data) => {
    setCisConfSelected(data)
    openDeleteUserModal()
    
  };
  function openDeleteUserModal() {
    setdeleteCisModalOpen(true);
  }

  function closDeleteCisModal() {
    setdeleteCisModalOpen(false);
    buscar_cis_history()
  }
  const handleChangReqAuth =(element)=>{
    if(element.status=='No iniciado'){
      // requests_auth(element)
      handleActionResponse(element)
    }else{
      cancel_auth(element)
    }
  }
  function requests_auth(element,txtarea){
    const data={
      process_id: 1,
      comments: txtarea
    }
    setLoading(true)
    setRegisterIsValid(true)
    const fetchDataPost = async () => {
      let url=server.url+'/api/v1/cassia/ci_elements/history/authorization/create/'+element.conf_id
   try {
     const response = await fetch(url, {
       method: 'POST',  
       headers: {
         'Content-Type': 'application/json',
         Authorization: `Bearer ${localStorage.getItem('access_token')}`,
       },
       body: JSON.stringify(data),
     });
     if (response.ok) {
       
       const data1 = await response.json();
       setLoading(false)
       setRegisterIsValid(false)
       // Manejo de la respuesta
       setData(data1)
       closDeleteCisModal()
       // console.log(data1);
     } else {
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
        // Manejo de errores
        setError(error)
        console.error(error);
      }
    };

    fetchDataPost();
  }
  function cancel_auth(element){
    const data={
      process_id: 1,
      comments: "comentario de prueba"
    }
    setLoading(true)
    setRegisterIsValid(true)
    const fetchDataPost = async () => {
      let url=server.url+'/api/v1/cassia/ci_elements/history/authorization/cancel/'+element.conf_id
   try {
     const response = await fetch(url, {
       method: 'POST',  
       headers: {
         'Content-Type': 'application/json',
         Authorization: `Bearer ${localStorage.getItem('access_token')}`,
       },
     });
     if (response.ok) {
       
       const data1 = await response.json();
       setLoading(false)
       setRegisterIsValid(false)
       // Manejo de la respuesta
       setData(data1)
       closDeleteCisModal()
       // console.log(data1);
     } else {
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
        // Manejo de errores
        setError(error)
        console.error(error);
      }
    };

    fetchDataPost();
  }
  return (
    <div className='cont-table-portafolio'>
                                    <div className={"head-table-portafolio"+mode}>
                                    <div className="compact-head-table-portafolio">
                                    <div className='field-head-table-cis-config field-small'>
                                            No.
                                        </div>
                                        <div className='field-head-table-cis-config field-medium'>
                                            {capitalizeFirstLetter(lang[languaje]['tipo'])}
                                        </div>
                                        <div className='field-head-table-cis-config field-larger'>
                                        {capitalizeFirstLetter(lang[languaje]['descripcion'])}
                                        </div>
                                        <div className='field-head-table-cis-config field-medium'>
                                        {capitalizeFirstLetter(lang[languaje]['justificacion'])}
                                        </div>
                                        <div className='field-head-table-cis-config field-medium'>
                                             {capitalizeFirstLetter(lang[languaje]['noSerie'])}
                                        </div>
                                        <div className='field-head-table-cis-config field-medium'>
                                        {capitalizeFirstLetter(lang[languaje]['marca'])}
                                        </div>
                                        <div className='field-head-table-cis-config field-medium'>
                                        {capitalizeFirstLetter(lang[languaje]['modelo'])}
                                        </div>
                                        <div className='field-head-table-cis-config field-medium'>
                                        {capitalizeFirstLetter(lang[languaje]['version'])}
                                        </div>
                                        <div className='field-head-table-cis-config field-medium'>
                                            Ticket
                                        </div>
                                        <div className='field-head-table-cis-config field-medium'>
                                        {capitalizeFirstLetter(lang[languaje]['responsable'])}
                                        </div>
                                        <div className='field-head-table-cis-config field-medium'>
                                        {capitalizeFirstLetter(lang[languaje]['autoriza'])}
                                        </div>
                                        <div className='field-head-table-cis-config field-medium'>
                                        {capitalizeFirstLetter(lang[languaje]['fechaInicio'])}
                                        </div>
                                        <div className='field-head-table-cis-config field-medium'>
                                        {capitalizeFirstLetter(lang[languaje]['fechaFin'])}
                                        </div>
                                        <div className='field-head-table-cis-config field-medium '  >
                                            Status
                                        </div>
                                        <div className='field-head-table-cis field-larger '>
                                        {capitalizeFirstLetter(lang[languaje]['acciones'])}
                                        </div>
                                        
                                    </div>
                                        
                                        
                                    </div>
                                    <div className='body-table-cis-config'>
                                    <>
        <div className='cont-row-user-list'>
        {(dataCisConf.loading ) ?<div className='cont-load-user-list'><LoadSimple></LoadSimple></div>:
          // console.log(elemento)
        //    (dataCisConf.data.length>0)?
        // dataCisConf.data.data.history.map((elemento, indice) => (
          dataList.map((elemento, indice) => (
            <div className={"row-table-portafolio"+mode} key={indice}   >
              <div className='field-body-table-cis field-small' style={{overflow: 'auto'}}>
                {elemento.conf_id}
              </div>
              <div className='field-body-table-cis field-medium' style={{overflow: 'auto'}}>
                {elemento.change_type}
              </div>
              <div className='field-body-table-cis field-larger' style={{overflow: 'auto'}}>
                {elemento.description}
              </div>
              <div className='field-body-table-cis field-medium' style={{overflow: 'auto'}}>
                {elemento.justification}
              </div>
              <div className='field-body-table-cis field-medium' style={{overflow: 'auto'}}>
                {elemento.hardware_no_serie}
              </div>
              <div className='field-body-table-cis field-medium' style={{overflow: 'auto'}}>
                {elemento.hardware_brand}
              </div>
              <div className='field-body-table-cis field-medium'style={{overflow: 'auto'}}>
                {elemento.hardware_model}
              </div>
              <div className='field-body-table-cis field-medium'style={{overflow: 'auto'}}>
                {elemento.software_version}
              </div>
              <div className='field-body-table-cis field-medium'style={{overflow: 'auto'}}>
                {elemento.ticket}
              </div>
              <div className='field-body-table-cis field-medium'style={{overflow: 'auto'}}>
                {elemento.responsible_name}
              </div>
              <div className='field-body-table-cis field-medium'style={{overflow: 'auto'}}>
                {elemento.auth_name}
              </div>
              <div className='field-body-table-cis field-medium'style={{overflow: 'auto'}}>
               
                {(elemento.created_at=="NaT")?'':elemento.created_at.slice(0,10)}
              </div>
              <div className='field-body-table-cis field-medium'style={{overflow: 'auto'}}>
                {(elemento.closed_at=="NaT")?'':elemento.closed_at.slice(0,10)}
              </div>
              <div className={'field-body-table-cis field-medium field-status txtCis'+elemento.status} style={{overflow: 'auto'}}>
                <p className='Tooltip-coment' >{elemento.authorization_comments}</p>
                {elemento.status}
              </div>
              
              <div className='field-body-table-cis field-larger '>
                <div  style={{width:'33%'}}>
                  {
                    (elemento.status=='No iniciado'  )?
                 
                  <img className='img-field-acciones' style={{width:'40%'}} src={((elemento.status=='No iniciado')?'/iconos/peticion.png':(elemento.status=='Pendiente de autorizacion')?'/iconos/cancel.png':'')} title='Peticion' name='Peticion' ci_id={elemento.ci_id} onClick={(e) =>{e.stopPropagation(); handleChangReqAuth(elemento)}} />:''
                }
                  </div>
                <div style={{width:'33%'}}>
                  {
                  (elemento.status!='Cerrada' && elemento.status!='Cancelada'   && elemento.status!='Rechazada')?
                  <img className='img-field-acciones'  style={{width:'40%'}} src='/iconos/editar.png' title='Editar' name='Editar' ci_id={elemento.ci_id} onClick={(e) =>{e.stopPropagation(); handleChangEdit(elemento)}} />:''
                  }
                  </div>
                <div style={{width:'33%'}} >
                {
                  (elemento.status=='No iniciado' )?
                  <img className='img-field-acciones' style={{width:'40%'}} src='/iconos/delete.png' title='Eliminar'name='Eliminar' ci_id={elemento.ci_id} onClick={(e)=> {e.stopPropagation(); handledeleteUserClick(elemento)}} />:''
                
                }
                  </div>
              </div>
              {
          (dataList.length==0)?<div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}</div>:''
        }
            </div>
          ))
        }
        {
        //   (dataList.length==0)?<div className="no-results">SIN RESULTADOS.</div>:''
        }
      </div>
      <Modal
        isOpen={deleteCisModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteCisModal}
        style={deleteCisModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          {/* <ModalDeleteCis server={server}      closDeleteCisModal={closDeleteCisModal}></ModalDeleteCis> */}
          <ModalDeleteCis languaje={languaje} mode={mode} server={server} setRegisterIsValid ={setRegisterIsValid } setData={setData} setLoading={setLoading} setError={setError} cis={cisConfSelected} closDeleteCisModal={closDeleteCisModal}></ModalDeleteCis>
    </Modal>
    <Modal
        isOpen={deleteBuzonModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteBuzonModal}
        style={deleteBuzonModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalReqAuth server={server}  requests_auth={ requests_auth}  setRegisterIsValid ={setRegisterIsValid } setData={setData} setLoading={setLoading} setError={setError} Buzon={userSelected} closDeleteBuzonModal={closDeleteBuzonModal}></ModalReqAuth>
    </Modal>
    </>
                                        
                                    </div>
                                </div>
  );
}

export default TableCisConfig;
